import { Component, Input } from '@angular/core';
import { IntentSourceEnum } from 'src/app/shared/enums';

@Component({
    selector: 'app-no-predictiveintent-plan',
    templateUrl: './no-predictiveintent-plan.component.html',
    standalone: false
})
export class NoPredictiveintentPlanComponent {
    @Input() intentSource: IntentSourceEnum | 'BOTH' = IntentSourceEnum.SALES_INTEL;
}
